import { render, staticRenderFns } from "./SMTP.vue?vue&type=template&id=6b63a644&scoped=true"
import script from "./SMTP.vue?vue&type=script&lang=js"
export * from "./SMTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63a644",
  null
  
)

export default component.exports